import { useCompany } from '@/hooks/use-company';
import { useSystemNotifications } from '@/hooks/use-system-notifications';
import { useEffect } from 'react';

export function CompanyVisibilityAlert() {
  const { activeCompany } = useCompany();
  const { addNotification, removeNotification } = useSystemNotifications();
  const companyId = activeCompany?.id;
  const notificationId = companyId ? `company-public-visibility-${companyId}` : null;
  const isHiddenFromPublic =
    Boolean(activeCompany) && !activeCompany?.showInPublicListing && !activeCompany?.publicPageEnabled;

  useEffect(() => {
    if (!notificationId) return;

    if (isHiddenFromPublic) {
      addNotification({
        id: notificationId,
        severity: 'warning',
        title: 'Sua empresa não está visível ao público',
        message: 'Ative a página pública ou a listagem para ser encontrada por clientes.',
        dismissible: false,
        action: {
          label: 'Revisar configurações',
          href: '/settings?tab=operation#public-visibility',
        },
      });
    } else {
      removeNotification(notificationId);
    }

    return () => removeNotification(notificationId);
  }, [addNotification, isHiddenFromPublic, notificationId, removeNotification]);

  return null;
}
